import { Component, inject, signal } from '@angular/core'
import { RouterOutlet } from '@angular/router'
import { FaIconLibrary } from '@fortawesome/angular-fontawesome'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import { FooterComponent } from './shared/components/footer/footer.component'

@Component({
    selector: 'app-root',
    imports: [RouterOutlet, FooterComponent],
    templateUrl: './app.html',
    styleUrl: './app.scss',
})
export class App {
    protected readonly title = signal('SurefireQuoting.Spa.Front')
    constructor() {
        const library = inject(FaIconLibrary)
        library.addIconPacks(fas, far)
    }
}
